export default __webpack_public_path__ + "media/images/slider-left-arrow-blue-849e3fb7fcdf31223c027d4e27353f33.svg";